import { Link } from "react-router-dom";
import ShowcaseCard from "../ui/ShowcaseCard";
import "./Showcase.css";
import bruschetta from "../../assets/bruchetta.svg";
import greekSalad from "../../assets/greek salad.jpg";
import lemonDessert from "../../assets/lemon dessert.jpg";

const menus = [
  {
    title: "Bruschetta",
    description:
      "Our Bruschetta is made from grilled bread that has been smeared with garlic and seasoned with salt and olive oil.",
    price: "$5.99",
    image: bruschetta,
    alt: "Bruschetta",
  },
  {
    title: "Greek Salad",
    description:
      "The famous greek salad of crispy lettuce, peppers, olives and our Chicago style feta cheese, garnished with crunchy garlic and rosemary croutons.",
    price: "$12.99",
    image: greekSalad,
    alt: "Greek Salad",
  },
  {
    title: "Lemon Tart",
    description:
      "This comes straight from grandma’s recipe book, every last ingredient has been sourced and is as authentic as can be imagined.",
    price: "$5.00",
    image: lemonDessert,
    alt: "Lemon Tart",
  },
];

export default function Showcase() {
  return (
    <section id="showcase" className="container grid">
      {/* Header */}
      <div id="showcase-header">
        <h2
          style={{
            fontFamily: "Markazi Text",
            fontWeight: 500,
            fontSize: "2.5rem",
          }}
        >
          Our Menus
        </h2>
        <Link to="/menu" className="button-primary">
          All Menu
        </Link>
      </div>
      {/* Cards */}
      <article id="showcase-cards">
        {menus.map((item, index) => (
          <ShowcaseCard key={index} item={item} />
        ))}
      </article>
    </section>
  );
}
